/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

const catalog = {
  locale: 'en',
  messages: {
    'about.about': 'About Memokid',
    'about.versionTitle': 'Version',
    'about.devTitle': 'Design & Development',
    'about.artTitle': 'Artwork',
    'about.artValue': 'The drawings on the cards of this game come from http://www.openclipart.org. The author thanks the many artists from this site',
    'about.translationsTitle': 'Translations',
    'about.trLanguage': 'Language',
    'about.trTranslator': 'Translator',
    'about.thanksTitle': 'Thanks',
    'about.thanksValue': "Christophe Porteneuve @ <a href='http://delicious-insights.com'>Delicious Insights</a> for his excellent ES2015 and React training",
    'about.copyrightTitle': 'License',
    'about.copyrightValue': '© 2017-2023 Lukas Laag. This software is licensed under <a href="https://www.gnu.org/licenses/gpl-3.0.en.html">GPLv3</a>. For details, source code and other versions, see <a href="https://webinstit.net/memokid/">webinstit.net</a>',
    'common.home': 'home',
    'common.cancel': 'cancel',
    'common.add': 'add',
    'common.modify': 'modify',
    'common.remove': 'remove',
    'common.ok': 'ok',
    'common.loading': 'Loading...',
    'decks.deck_0': 'Christmas',
    'decks.deck_1': 'Uppercase characters',
    'decks.deck_2': 'Animals',
    'decks.deck_3': 'Animated Animals',
    'decks.deck_4': 'Food',
    'decks.deck_5': 'Transportation',
    'decks.deck_6': 'Lowercase characters',
    'decks.deck_7': 'Digits',
    'decks.deck_8': 'Music instruments',
    'decks.deck_9': 'Flags',
    'decks.deck_10': 'Kitchen Gear',
    'decks.deck_11': 'Easter',
    'game.stopMessage': 'Stop the current game and return to the home screen ?',
    'game.demo': 'demo {id}',
    'game.player': 'Player',
    'game.computer': 'Computer',
    'game.gameOver': 'Game Over',
    'game.win': '{players} wins the game. Congratulations !',
    'game.win_plural': '{players} wins the game. Congratulations !',
    'game.draw': 'Draw. Congratulations to all players !',
    'game.conjunction': 'and',
    'scores.title': 'Last games scores',
    'scores.noscores': 'No games have been played yet',
    'scores.when': 'When',
    'scores.players': 'Players',
    'scores.scores': 'Scores',
    'scores.vs': 'vs',
    'scores.to': 'to',
    'settings.deckHeader': 'Card decks',
    'settings.plyCountHeader': 'Number of cards per ply',
    'settings.cardCountHeader': 'Number of cards in the deck',
    'settings.playersHeader': 'Players',
    'settings.addPlayer': 'Add a player',
    'settings.modifyPlayer': 'Modify a player',
    'settings.removePlayerMessage': "Do you want to remove the ''{player}'' player ?",
    'settings.playerLabel': 'Player name',
    'settings.playerTypeHeader': 'Type of player',
    'settings.humanPlayer': 'Human player',
    'settings.computerPlayer': 'Computer',
    'settings.computerLevelHeader': 'Computer Strength',
    'settings.language': 'Language',
    'title.aboutButton': 'about',
    'title.settingsButton': 'settings',
    'title.scoresButton': 'scores',
    'title.newGameButton': 'new game',
    'title.gameType': 'Type of game: {cardCount} cards, {matchCount} cards per ply',
    'title.player': '1 Player',
    'title.player_plural': '{count} Players',
    'title.playerLevel': 'level {level}'
  }
}
export default catalog
